<template>
  <TheHeader>
    <DashboardContentSaib />
    <DashboardContentExchange />
    <DashboardContentBalance />
    <DashboardContentBroadcast />
    <DashboardContentQuestion />
  </TheHeader>
</template>
<script>
import DashboardContentSaib from "@/components/DashboardContent/DashboardContentSaib";
import DashboardContentExchange from "@/components/DashboardContent/DashboardContentExchange";
import DashboardContentQuestion from "@/components/DashboardContent/DashboardContentQuestion";
import DashboardContentBroadcast from "@/components/DashboardContent/DashboardContentBroadcast";
import DashboardContentBalance from "@/components/DashboardContent/DashboardContentBalance";
import TheHeader from "@/components//TheLayout/TheHeader";

export default {
  name: "Dashboard",
  components: {
    DashboardContentSaib,
    DashboardContentExchange,
    DashboardContentQuestion,
    DashboardContentBroadcast,
    DashboardContentBalance,
    TheHeader
  }
};
</script>